import { Dispatch, SetStateAction } from 'react'
import { QRCode } from 'react-qr-code'
import AssignmentIcon from '@mui/icons-material/Assignment'
import { Box, DialogContent, Grid, IconButton, Link, Tooltip } from '@mui/material'

import { BRANCH_URL } from '../../utils/constants'
import useClipboard from '../../utils/hooks/useClipboard'
import useSharedStyles from '../../utils/shared.styles'
import DialogWithTitle from '../dialog-with-title'

import useStyles from './index.styles'

interface IProps {
  user: IUserType
  showImpersonateDialog: boolean
  setShowImpersonateDialog: Dispatch<SetStateAction<boolean>>
}

const ImpersonateInMobileDialog = (props: IProps) => {
  const { user, setShowImpersonateDialog, showImpersonateDialog } = props

  const classes = useStyles
  const sharedClasses = useSharedStyles
  const { clickToCopy } = useClipboard()

  // branch io link that will work across environments
  const impersonateLink = `${BRANCH_URL}/impersonate?ref=${user?.id}`

  const copyToClipboard = () => {
    clickToCopy(impersonateLink)
  }

  return (
    <DialogWithTitle open={showImpersonateDialog} setOpen={setShowImpersonateDialog} title="Impersonate in Protect Mobile">
      <DialogContent>
        <Grid container={true} spacing={3}>
          <Grid container={true} size={12} sx={sharedClasses.centerContentHorizontal}>
            Scan QR code with your mobile device's camera
          </Grid>

          <Grid container={true} size={12} sx={sharedClasses.centerContentHorizontal}>
            <Box sx={classes.qrContainer}>
              <QRCode value={impersonateLink} size={192} level="M" />
            </Box>
          </Grid>

          <Grid container={true} className="fs-exclude" size={12} sx={sharedClasses.centerContentHorizontal}>
            {user?.email}
          </Grid>

          <Grid container={true} size={12} sx={[sharedClasses.centerContentHorizontal, classes.protectMobileLink]}>
            <Link href={impersonateLink} target="_blank">
              Or click the link here
            </Link>

            <Tooltip title="Copy impersonate link to clipboard" arrow={true} placement="top">
              <IconButton onClick={copyToClipboard} aria-label="Copy link to clipboard">
                <AssignmentIcon color="secondary" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </DialogContent>
    </DialogWithTitle>
  )
}

export default ImpersonateInMobileDialog
